import { Component, Input, OnInit } from '@angular/core';
import { EventsService, PaymentV2Service, UtilService, VariablesService } from '../../shared/services';

@Component({
  selector: 'app-sip-card-assured',
  templateUrl: './sip-card-assured.component.html',
  styleUrls: ['./sip-card-assured.component.scss']
})
export class SipCardAssuredComponent implements OnInit {

  @Input() supporterImg;
  @Input() slabs = true;
  @Input() redirectTo;
  @Input() redirectWitQuery = {};
  @Input() currency = 'INR';
  @Input() preTitle = 'Continue to create more impact with';
  toggle;
  subsCount;

  constructor(
    public vars: VariablesService,
    public paymentV2: PaymentV2Service,
    public utilService: UtilService,
    private events: EventsService
  ) { }

  ngOnInit() {
    this.vars.getSubsCount();
    this.vars.subsCount.subscribe((res: any) => {
      this.subsCount = res;
    });
  }


  toggleBtn() {
    this.events.sendSystemEvent({
      eventName: 'give_monthly_new',
      page_name: this.vars.pageName,
      info_3: 'impact'
    }).subscribe(_ => _);

    if (this.redirectTo) {
      this.utilService.redirectWithUTM(this.redirectTo, this.redirectWitQuery);
    } else {
      this.utilService.router.navigate(['/new/sip/payment-standalone'],
        {
          queryParams: { currency: this.currency, amt: this.paymentV2.getMinSipAmount(this.currency).amount },
          queryParamsHandling: 'merge'
        }
      );
    }
  }

}
